// ── Importaciones tal cual ──────────────────────────────
import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col, ListGroup, Badge, Form } from 'react-bootstrap';
import SmartpayModal from '../../Modal/Modal';
import ModalAsingPaymetMethod from './ModalAsingPaymetMethod';
import { MachinesFetchAPI } from '../../../api/Machines';
import { PaymentMethodFetchAPI } from '../../../api/PaymentMethod';
import SuccessAlert from '../../Alerts/SuccessAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
import { RenderIf } from '../../utils/RenderIf';
import { checkUserPermission } from '../../utils/CheckUserPermitions';
import { checkUserModules } from '../../utils/CheckUserModules';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .mmd-
───────────────────────────────────────────────────────── */
const MMD_CSS = `
@keyframes mmd-up { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:translateY(0)} }

/* ── modal overrides ── */
.mmd-dialog .modal-content {
  border: 1.5px solid rgba(0,0,0,.08) !important;
  border-radius: 20px !important;
  box-shadow: 0 28px 70px rgba(0,0,0,.18), 0 6px 18px rgba(0,0,0,.08) !important;
  overflow: hidden !important;
}
.mmd-dialog .modal-header {
  background: linear-gradient(135deg,#0F2444 0%,#1B3A6B 60%,#1E4080 100%) !important;
  border-bottom: none !important;
  padding: .95rem 1.35rem !important;
  color: #fff !important;
  font-size: .93rem !important;
  font-weight: 700 !important;
  font-family: var(--font-sans,-apple-system,sans-serif) !important;
}
.mmd-dialog .modal-header .btn-close { filter: invert(1) brightness(2) !important; }
.mmd-dialog .modal-body   { padding: 1.25rem !important; background: #F8F8F8 !important; }
.mmd-dialog .modal-footer {
  border-top: 1px solid rgba(0,0,0,.07) !important;
  background: #fff !important; padding: .75rem 1.25rem !important;
}
.mmd-dialog .modal-footer .btn { border-radius: 9px !important; font-size: .81rem !important; }

/* ── section wrapper ── */
.mmd-section {
  background: #fff;
  border: 1.5px solid rgba(0,0,0,.07);
  border-radius: 14px;
  margin-bottom: 1rem;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,.04);
  animation: mmd-up .22s ease both;
}
.mmd-section-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: .65rem 1rem;
  border-bottom: 1px solid rgba(0,0,0,.07);
  background: rgba(27,58,107,.04);
}
.mmd-section-title {
  font-size: .72rem; font-weight: 700; letter-spacing: .07em;
  text-transform: uppercase; color: #1B3A6B;
  font-family: var(--font-sans,-apple-system,sans-serif);
  display: flex; align-items: center; gap: .38rem;
}
.mmd-section-body { padding: .9rem 1rem; }

/* ── code cards (pin ingreso) ── */
.mmd-codes {
  display: grid; grid-template-columns: repeat(3,1fr); gap: .75rem;
}
@media(max-width: 640px){ .mmd-codes { grid-template-columns: 1fr; } }
.mmd-code-card {
  background: linear-gradient(135deg,#1B3A6B 0%,#2563EB 100%);
  border-radius: 12px; padding: .9rem 1rem; text-align: center;
  box-shadow: 0 4px 14px rgba(27,58,107,.25);
}
.mmd-code-label {
  font-size: .67rem; font-weight: 600; letter-spacing: .06em;
  text-transform: uppercase; color: rgba(255,255,255,.6); margin-bottom: .3rem;
}
.mmd-code-value {
  font-size: 1.35rem; font-weight: 800; color: #fff;
  letter-spacing: .05em; word-break: break-all;
}

/* ── info grid ── */
.mmd-info-grid {
  display: grid; grid-template-columns: repeat(auto-fill, minmax(180px,1fr)); gap: .65rem;
}
.mmd-info-cell {
  background: #F9FAFB;
  border: 1.5px solid rgba(0,0,0,.07);
  border-radius: 10px; padding: .65rem .85rem;
  display: flex; flex-direction: column; gap: .2rem;
}
.mmd-info-label {
  font-size: .67rem; font-weight: 700; letter-spacing: .05em;
  text-transform: uppercase; color: #9CA3AF;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.mmd-info-value {
  font-size: .82rem; font-weight: 600; color: #111827;
  font-family: var(--font-sans,-apple-system,sans-serif);
}
.mmd-info-cell-wide { grid-column: span 2; }
@media(max-width: 560px) { .mmd-info-cell-wide { grid-column: span 1; } }

/* edit button */
.mmd-btn-edit {
  width: 26px; height: 26px; border-radius: 7px; flex-shrink: 0;
  border: 1.5px solid rgba(27,58,107,.2); background: rgba(27,58,107,.07); color: #1B3A6B;
  display: grid; place-items: center; cursor: pointer; transition: all .13s;
}
.mmd-btn-edit:hover { background: #1B3A6B; color: #fff; }

.mmd-info-row-head {
  display: flex; align-items: center; justify-content: space-between; margin-bottom: .15rem;
}

/* ── status badges ── */
.mmd-badge-on  { display:inline-flex;align-items:center;gap:.25rem;padding:.18rem .55rem;border-radius:999px;font-size:.67rem;font-weight:700;background:rgba(34,197,94,.12);color:#15803D;border:1px solid rgba(34,197,94,.25); }
.mmd-badge-off { display:inline-flex;align-items:center;gap:.25rem;padding:.18rem .55rem;border-radius:999px;font-size:.67rem;font-weight:700;background:rgba(239,68,68,.1);color:#991B1B;border:1px solid rgba(239,68,68,.2); }
.mmd-badge-lay { display:inline-flex;align-items:center;gap:.25rem;padding:.18rem .55rem;border-radius:999px;font-size:.67rem;font-weight:700;background:rgba(37,99,235,.1);color:#1D4ED8;border:1px solid rgba(37,99,235,.2); }

/* ── categories ── */
.mmd-cat-grid { display: flex; flex-wrap: wrap; gap: .5rem; }
.mmd-cat-pill {
  display: inline-flex; align-items: center; gap: .4rem;
  padding: .32rem .75rem; border-radius: 999px;
  border: 1.5px solid rgba(0,0,0,.1); background: #F9FAFB;
  font-size: .78rem; font-weight: 600; color: #374151;
  font-family: var(--font-sans,-apple-system,sans-serif);
  animation: mmd-up .18s ease both;
}
.mmd-cat-remove {
  width: 18px; height: 18px; border-radius: 50%; border: none;
  background: rgba(239,68,68,.12); color: #EF4444;
  display: grid; place-items: center; cursor: pointer;
  transition: all .12s; flex-shrink: 0;
}
.mmd-cat-remove:hover { background: #EF4444; color: #fff; }

.mmd-cat-empty {
  padding: .85rem; border-radius: 10px;
  background: rgba(251,191,36,.08); border: 1px solid rgba(251,191,36,.25);
  color: #92400E; font-size: .79rem;
  font-family: var(--font-sans,-apple-system,sans-serif);
  display: flex; align-items: center; gap: .5rem; width: 100%;
}

/* ── network grid ── */
.mmd-net-grid {
  display: grid; grid-template-columns: repeat(auto-fill, minmax(160px,1fr)); gap: .65rem;
}
.mmd-net-cell {
  background: #F9FAFB; border: 1.5px solid rgba(0,0,0,.07);
  border-radius: 10px; padding: .6rem .85rem;
}
.mmd-net-label { font-size: .65rem; font-weight: 700; letter-spacing: .05em; text-transform: uppercase; color: #9CA3AF; margin-bottom: .15rem; font-family: var(--font-sans,-apple-system,sans-serif); }
.mmd-net-value { font-size: .8rem; font-weight: 600; color: #111827; font-family: monospace; word-break: break-all; }

/* ── payment methods ── */
.mmd-pm-grid { display: grid; grid-template-columns: repeat(auto-fill,minmax(260px,1fr)); gap: .7rem; }
.mmd-pm-card {
  background: #fff; border: 1.5px solid rgba(0,0,0,.08); border-radius: 13px;
  padding: .85rem; display: flex; flex-direction: column; gap: .6rem;
  box-shadow: 0 1px 4px rgba(0,0,0,.04); animation: mmd-up .2s ease both;
}
.mmd-pm-head { display: flex; align-items: flex-start; justify-content: space-between; gap: .5rem; }
.mmd-pm-name { font-size: .82rem; font-weight: 700; color: #111827; font-family: var(--font-sans,-apple-system,sans-serif); line-height: 1.4; }
.mmd-pm-params { display: flex; flex-direction: column; gap: .3rem; }
.mmd-pm-param {
  display: flex; align-items: center; justify-content: space-between;
  padding: .38rem .65rem; border-radius: 8px;
  background: #F9FAFB; border: 1px solid rgba(0,0,0,.07);
  font-size: .75rem; color: #374151; font-family: var(--font-sans,-apple-system,sans-serif);
}
.mmd-pm-param-name { color: #9CA3AF; font-weight: 500; }
.mmd-pm-param-val  { font-weight: 600; color: #111827; margin-left: .35rem; }
.mmd-btn-param-edit {
  width: 24px; height: 24px; border-radius: 6px; border: none;
  background: rgba(251,191,36,.12); color: #D97706;
  display: grid; place-items: center; cursor: pointer; transition: all .12s; flex-shrink: 0;
}
.mmd-btn-param-edit:hover { background: #D97706; color: #fff; }
.mmd-pm-foot { display: flex; align-items: center; justify-content: flex-end; }
.mmd-btn-pm-del {
  display: inline-flex; align-items: center; gap: .3rem;
  padding: .28rem .65rem; border-radius: 7px; border: none;
  background: rgba(239,68,68,.08); color: #EF4444;
  font-size: .73rem; font-weight: 600; cursor: pointer; font-family: inherit;
  transition: all .12s;
}
.mmd-btn-pm-del:hover { background: #EF4444; color: #fff; }

/* ── add buttons ── */
.mmd-btn-add {
  display: inline-flex; align-items: center; gap: .35rem;
  padding: .38rem .85rem; border-radius: 8px;
  border: 1.5px solid rgba(27,58,107,.2); background: rgba(27,58,107,.07);
  color: #1B3A6B; font-size: .77rem; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: all .14s;
}
.mmd-btn-add:hover { background: #1B3A6B; color: #fff; }

/* ── form switch override ── */
.mmd-pm-card .form-check-input:checked { background-color: #1B3A6B !important; border-color: #1B3A6B !important; }

@media(max-width: 640px) {
  .mmd-pm-grid   { grid-template-columns: 1fr; }
  .mmd-info-grid { grid-template-columns: repeat(auto-fill, minmax(140px,1fr)); }
  .mmd-codes     { grid-template-columns: 1fr; }
}
`;

/* ── ICONS ── */
const IcoMonitor = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>;
const IcoInfo    = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;
const IcoTag     = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>;
const IcoWifi    = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/></svg>;
const IcoCrd     = ()=><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>;
const IcoKey     = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>;
const IcoPlus    = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IcoPen     = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4z"/></svg>;
const IcoTrash   = ()=><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M10 11v6M14 11v6M9 6V4h6v2"/></svg>;
const IcoX       = ()=><svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;

const StatusBadge = ({ on }) => on
  ? <span className="mmd-badge-on">● Activo</span>
  : <span className="mmd-badge-off">● Inactivo</span>;

const NA = ({ v }) => (v != null && v !== "") ? v : <span style={{ color: '#9CA3AF', fontSize: '.75rem' }}>No registrado</span>;

/* ════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original
════════════════════════════════════════════════════════ */
const ModalMachineDetails = ({
  warehouses, userCategories, paymentMethodIntegrations, userBranchoffices,
  showModal, setShowModal, machine_id, token, eventHandler, setEventHandler, user
}) => {

  useEffect(() => {
    const id = "mmd-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id; el.textContent = MMD_CSS;
      document.head.appendChild(el);
    }
  }, []);

  /* ════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════ */
  const [machineDetails, setMachineDetails] = useState({
    name:"",status:0,type:"",branchoffice_name:"",branchoffice_code:"",code:"",business_code:"",warehouse:null
  });
  const [modalFields, setModalFields] = useState([
    { name:'branchoffice_id', label:'Sucursal', type:'select', options:userBranchoffices, required:true }
  ]);
  const [modalFieldsCategory, setModalFieldsCategory] = useState([
    { name:'category_id', label:'Categoria', type:'select', options:userCategories, required:true }
  ]);
  const [modalFieldsEditParamValue, setModalFieldsEditParamValue] = useState([
    { name:'param_value', label:'Valor del parametro', type:'text', required:true }
  ]);
  const [modalFieldsWarehouses, setModalFieldsWarehouses] = useState([
    { name:'warehouse_id', label:'Warehouse', type:'select', options:warehouses, required:true }
  ]);
  const [formData, setFormData]                             = useState({});
  const [machinePaymentMethods, setPaymentMethods]          = useState([]);
  const [machineCategories, setCategories]                  = useState([]);
  const [showAsingBranchModal, setShowAsingBranchModal]     = useState(false);
  const [showAsingWarehouseModal, setShowAsingWarehouseModal] = useState(false);
  const [showAsingCategoryModal, setShowAsingCategoryModal] = useState(false);
  const [showAsingPaymentMethodModal, setShowAsingPaymentMethodModal] = useState(false);
  const [showEditParamValueModal, setShowEditParamValueModal] = useState(false);

  const handleFieldChange = (fieldName, value) => {
    setFormData(prevData => ({ ...prevData, [fieldName]: value }));
  };

  const getMachineDetails = async () => {
    try {
      const machine        = await MachinesFetchAPI.getmachineByid(machine_id, token);
      const paymentMethods = await MachinesFetchAPI.getMachinePaymentMethods(machine_id, token);
      setMachineDetails({
        name: machine.data.data.machine_name, status: machine.data.data.is_logged,
        type: machine.data.data.name_type_machine, subtype: machine.data.data.subtype,
        windows_ip: machine.data.data.windows_ip, android_ip: machine.data.data.android_ip,
        mcadress_wifi: machine.data.data.mcadress_wifi, mcadress_lan: machine.data.data.mcadress_lan,
        layaout: machine.data.data.layaout_id, machine_menu: machine.data.data.machine_menu,
        devolution: machine.data.data.machine_return,
        machine_pre_accounts: machine.data.data.machine_pre_accounts,
        machine_discounts: machine.data.data.machine_discounts,
        cupons: machine.data.data.machine_cupons, language: machine.data.data.language.name,
        branchoffice_name: machine.data.data.branchoffice_name,
        branchoffice_code: machine.data.data.branchoffice_code,
        code: machine.data.data.code, business_code: machine.data.data.business_code,
        warehouse: machine.data.data.warehouse
      });
      setCategories(machine.data.data.categories);
      setPaymentMethods(paymentMethods.data.data);
    } catch (err) {
      setMachineDetails({ name:"",status:0,type:"",subtype:"",windows_ip:"",android_ip:"",mcadress_wifi:"",mcadress_lan:"",layaout:0,machine_menu:0,devolution:0,machine_pre_accounts:0,machine_discounts:0,cupons:0,language:"",branchoffice_name:"" });
      setCategories([]); setPaymentMethods([]);
    }
  };

  const updateMachineParamPaymentMethodValue = async (e) => {
    e.preventDefault();
    try {
      let value = formData.param_value;
      let param_value_id = formData.param_value_id;
      await PaymentMethodFetchAPI.updatePaymentMethodParamValue(param_value_id, value, machine_id, token);
      getMachineDetails();
      SuccessAlert("Valor del parametro actualizado correctamente");
      setShowEditParamValueModal(false);
    } catch (err) { ErrorAlert("Error al actualizar el valor del parametro del metodo de pago","Error","error"); }
  };

  const handlePaymentMethodSwitch = async (paymentMethodId, integration_id, machine_id, newStatus) => {
    try {
      await PaymentMethodFetchAPI.updatePaymentMethod(machine_id, paymentMethodId, integration_id, newStatus ? 1 : 0, token);
      getMachineDetails();
      SuccessAlert("Metodo de pago actualizado correctamente");
    } catch (err) { console.error('Error al actualizar el método de pago:', err); ErrorAlert("Error al actualizar el método de pago"); }
  };

  const removePaymentMethod = async (paymentMethodId, integration_id, machine_id) => {
    try {
      await PaymentMethodFetchAPI.removePaymentMethod(machine_id, paymentMethodId, integration_id, token);
      getMachineDetails();
      SuccessAlert("Metodo de pago eliminado correctamente");
    } catch (err) { console.error('Error al eliminar el método de pago:', err); ErrorAlert("Error al eliminar el método de pago"); }
  };

  const asingBranchToMachine = async (e) => {
    e.preventDefault();
    try {
      await MachinesFetchAPI.updateMachineInfo({ branchoffice_id: formData.branchoffice_id }, machine_id, token);
      setShowAsingBranchModal(false);
      setEventHandler(1);
      SuccessAlert("Sucursal reasignada correctamente");
    } catch (err) { console.error('Error al asignar la sucursal a la máquina:', err); ErrorAlert("Error al asignar la sucursal a la máquina"); }
  };

  const asingWarehouseToMachine = async (e) => {
    e.preventDefault();
    try {
      await MachinesFetchAPI.updateMachineInfo({ warehouse_id: formData.warehouse_id }, machine_id, token);
      setShowAsingWarehouseModal(false);
      setEventHandler(1);
      SuccessAlert("Bodega asignada correctamente");
    } catch (err) { console.error('Error al asignar la bodega a la máquina:', err); ErrorAlert("Error al asignar la bodega a la máquina"); }
  };

  const asingCategoryToMachine = async (e) => {
    e.preventDefault();
    try {
      let category_id = formData.category_id;
      await MachinesFetchAPI.asingCategoryToMachine(machine_id, category_id, token);
      setShowAsingCategoryModal(false);
      setEventHandler(1);
      SuccessAlert("Categoria asignada correctamente");
    } catch (err) {
      if (err.response.status === 400) ErrorAlert("La categoria ya esta asignada a la máquina","Advertencia","warning");
      else ErrorAlert("Error al asignar la categoria a la máquina","Error","error");
    }
  };

  const removeCategoryFromMachine = async (category_id) => {
    try {
      await MachinesFetchAPI.removeCategoryFromMachine(machine_id, category_id, token);
      setEventHandler(1);
      SuccessAlert("Categoria eliminada correctamente");
    } catch (err) { console.error('Error al eliminar la categoria de la máquina:', err); ErrorAlert("Error al eliminar la categoria de la máquina"); }
  };

  useEffect(() => {
    let lastModalFields = modalFields;
    lastModalFields[0].options = userBranchoffices;
    lastModalFields[0].options = userBranchoffices.map(branch => ({ value: branch.branchoffice_id, label: branch.branchoffice_name }));
    lastModalFields[0].options.unshift({ value: 0, label: 'Seleccione una sucursal' });
    setModalFields(lastModalFields);

    let lastModalFieldsCategory = modalFieldsCategory;
    lastModalFieldsCategory[0].options = userCategories;
    lastModalFieldsCategory[0].options = userCategories.map(category => ({ value: category.category_id, label: category.category_name }));
    lastModalFieldsCategory[0].options.unshift({ value: 0, label: 'Seleccione una categoria' });
    setModalFieldsCategory(lastModalFieldsCategory);

    let lastModalFieldsWarehouses = modalFieldsWarehouses;
    console.log(warehouses);
    lastModalFieldsWarehouses[0].options = warehouses !== undefined && warehouses !== null ? warehouses : [];
    if (lastModalFieldsWarehouses[0].options.length !== 0) {
      lastModalFieldsWarehouses[0].options = warehouses.map(warehouse => ({ value: warehouse.id, label: warehouse.name }));
      lastModalFieldsWarehouses[0].options.unshift({ value: 0, label: 'Seleccione una bodega' });
    } else {
      lastModalFieldsWarehouses[0].options = [{ value: 0, label: 'Seleccione una bodega' }];
    }
    setModalFieldsWarehouses(lastModalFieldsWarehouses);
    getMachineDetails();
    setEventHandler(0);
  }, [eventHandler]);
  /* ════════════════════════════════════
     FIN LÓGICA ORIGINAL
  ════════════════════════════════════ */

  return (
    <>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" centered dialogClassName="mmd-dialog">

        <Modal.Header className="fw-bold fs-5" closeButton>
          <div style={{ display:'flex', alignItems:'center', gap:'.5rem' }}>
            <IcoMonitor /> Datos de la Máquina — <span style={{ fontWeight:400, opacity:.75 }}>{machineDetails.name || ''}</span>
          </div>
        </Modal.Header>

        <Modal.Body>

          {/* ── 1. PIN / CÓDIGOS ── */}
          <div className="mmd-section">
            <div className="mmd-section-head">
              <span className="mmd-section-title"><IcoKey /> Pin de Ingreso</span>
            </div>
            <div className="mmd-section-body">
              <div className="mmd-codes">
                <div className="mmd-code-card">
                  <div className="mmd-code-label">Código de Máquina</div>
                  <div className="mmd-code-value">{machineDetails.code != null && machineDetails.code !== "" ? machineDetails.code : 'Sin Código'}</div>
                </div>
                <div className="mmd-code-card">
                  <div className="mmd-code-label">Código de Sucursal</div>
                  <div className="mmd-code-value">{machineDetails.branchoffice_code != null ? machineDetails.branchoffice_code : 'Sin Código'}</div>
                </div>
                <div className="mmd-code-card">
                  <div className="mmd-code-label">Código de Empresa</div>
                  <div className="mmd-code-value">{machineDetails.business_code != null ? machineDetails.business_code : 'Sin Código'}</div>
                </div>
              </div>
            </div>
          </div>

          {/* ── 2. INFORMACIÓN GENERAL ── */}
          <div className="mmd-section">
            <div className="mmd-section-head">
              <span className="mmd-section-title"><IcoInfo /> Información General</span>
            </div>
            <div className="mmd-section-body">
              <div className="mmd-info-grid">

                <div className="mmd-info-cell">
                  <span className="mmd-info-label">Nombre</span>
                  <span className="mmd-info-value"><NA v={machineDetails.name} /></span>
                </div>

                <div className="mmd-info-cell">
                  <span className="mmd-info-label">Sesión</span>
                  <StatusBadge on={machineDetails.status === 1} />
                </div>

                <div className="mmd-info-cell">
                  <span className="mmd-info-label">Tipo</span>
                  <span className="mmd-info-value"><NA v={machineDetails.type} /></span>
                </div>

                <div className="mmd-info-cell">
                  <span className="mmd-info-label">Subtipo</span>
                  <span className="mmd-info-value"><NA v={machineDetails.subtype} /></span>
                </div>

                {/* sucursal con btn editar */}
                <div className="mmd-info-cell mmd-info-cell-wide">
                  <div className="mmd-info-row-head">
                    <span className="mmd-info-label">Sucursal de la Máquina</span>
                    <RenderIf isTrue={checkUserPermission("asing_branchoffice_machine", user.permissions) !== -1}>
                      <button className="mmd-btn-edit" onClick={() => setShowAsingBranchModal(true)}>
                        <IcoPen />
                      </button>
                    </RenderIf>
                  </div>
                  <span className="mmd-info-value">{machineDetails.branchoffice_name}</span>
                </div>

                <div className="mmd-info-cell">
                  <span className="mmd-info-label">Layout</span>
                  {machineDetails.layaout !== 1
                    ? <span className="mmd-badge-lay">LITE</span>
                    : <span style={{ display:'inline-flex', alignItems:'center', gap:'.25rem', padding:'.18rem .55rem', borderRadius:'999px', fontSize:'.67rem', fontWeight:700, background:'rgba(251,191,36,.12)', color:'#92400E', border:'1px solid rgba(251,191,36,.3)' }}>PLUS +</span>}
                </div>

                <div className="mmd-info-cell">
                  <span className="mmd-info-label">Cupones</span>
                  <StatusBadge on={machineDetails.cupons === 1} />
                </div>

                <div className="mmd-info-cell">
                  <span className="mmd-info-label">Módulo Menú</span>
                  <StatusBadge on={machineDetails.machine_menu === 1} />
                </div>

                <div className="mmd-info-cell">
                  <span className="mmd-info-label">Devoluciones</span>
                  <StatusBadge on={machineDetails.devolution === 1} />
                </div>

                <div className="mmd-info-cell">
                  <span className="mmd-info-label">Descuentos</span>
                  <StatusBadge on={machineDetails.machine_discounts === 1} />
                </div>

                <div className="mmd-info-cell">
                  <span className="mmd-info-label">Pre-cuentas</span>
                  <StatusBadge on={machineDetails.machine_pre_accounts === 1} />
                </div>

                <div className="mmd-info-cell">
                  <span className="mmd-info-label">Lenguaje</span>
                  <span className="mmd-info-value"><NA v={machineDetails.language} /></span>
                </div>

                <div className="mmd-info-cell">
                  <span className="mmd-info-label">Trx externas</span>
                  <span className="mmd-info-value">
                    {machineDetails.automatic_payment != 0 && machineDetails.automatic_payment != false ? 'Cerrará' : 'No cerrará'}
                  </span>
                </div>

              </div>
            </div>
          </div>

          {/* ── 3. INFO ADICIONAL (POS/Kiosk) ── */}
          <RenderIf isTrue={machineDetails.type === "Smart pos" || machineDetails.type === "Smart Pay"}>
            <div className="mmd-section">
              <div className="mmd-section-head">
                <span className="mmd-section-title"><IcoInfo /> Información Adicional</span>
              </div>
              <div className="mmd-section-body">
                <div className="mmd-info-grid">
                  <div className="mmd-info-cell">
                    <div className="mmd-info-row-head">
                      <span className="mmd-info-label">Bodega de la Máquina</span>
                      <button className="mmd-btn-edit" onClick={() => setShowAsingWarehouseModal(true)}><IcoPen /></button>
                    </div>
                    <span className="mmd-info-value">
                      {machineDetails.warehouse != null && machineDetails.warehouse !== "" ? machineDetails.warehouse.name : <span style={{ color:'#9CA3AF', fontSize:'.75rem' }}>No asignada</span>}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </RenderIf>

          {/* ── 4. CATEGORÍAS ── */}
          <div className="mmd-section">
            <div className="mmd-section-head">
              <span className="mmd-section-title"><IcoTag /> Categorías</span>
              <RenderIf isTrue={checkUserPermission("asing_category_machine", user.permissions) !== -1}>
                <button className="mmd-btn-add" onClick={() => setShowAsingCategoryModal(true)}>
                  <IcoPlus /> Agregar categoría
                </button>
              </RenderIf>
            </div>
            <div className="mmd-section-body">
              {machineCategories.length === 0 ? (
                <div className="mmd-cat-empty">
                  ⚠️ Aún no has agregado ninguna categoría. Las que añadas se mostrarán aquí.
                </div>
              ) : (
                <div className="mmd-cat-grid">
                  {machineCategories.map(category => (
                    <span className="mmd-cat-pill" key={category.category_id}>
                      {category.name}
                      <button className="mmd-cat-remove" onClick={() => removeCategoryFromMachine(category.category_id)}>
                        <IcoX />
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* ── 5. RED ── */}
          <div className="mmd-section">
            <div className="mmd-section-head">
              <span className="mmd-section-title"><IcoWifi /> Información de Red</span>
            </div>
            <div className="mmd-section-body">
              <div className="mmd-net-grid">
                <div className="mmd-net-cell">
                  <div className="mmd-net-label">Windows IP</div>
                  <div className="mmd-net-value"><NA v={machineDetails.windows_ip} /></div>
                </div>
                <div className="mmd-net-cell">
                  <div className="mmd-net-label">Android IP</div>
                  <div className="mmd-net-value"><NA v={machineDetails.android_ip} /></div>
                </div>
                <div className="mmd-net-cell">
                  <div className="mmd-net-label">MAC LAN</div>
                  <div className="mmd-net-value"><NA v={machineDetails.mcadress_lan} /></div>
                </div>
                <div className="mmd-net-cell">
                  <div className="mmd-net-label">MAC WiFi</div>
                  <div className="mmd-net-value"><NA v={machineDetails.mcadress_wifi} /></div>
                </div>
              </div>
            </div>
          </div>

          {/* ── 6. MÉTODOS DE PAGO ── */}
          <div className="mmd-section">
            <div className="mmd-section-head">
              <span className="mmd-section-title"><IcoCrd /> Métodos de Pago</span>
              <button className="mmd-btn-add" onClick={() => setShowAsingPaymentMethodModal(true)}>
                <IcoPlus /> Agregar método
              </button>
            </div>
            <div className="mmd-section-body">
              <div className="mmd-pm-grid">
                {machinePaymentMethods.map(pm => (
                  <div className="mmd-pm-card" key={pm.payment_id}>
                    <div className="mmd-pm-head">
                      <div>
                        <div className="mmd-pm-name">{pm.payment} — {pm.integration.name}</div>
                        {pm.status === 1
                          ? <span className="mmd-badge-on" style={{ marginTop:4, display:'inline-flex' }}>● Activo</span>
                          : <span className="mmd-badge-off" style={{ marginTop:4, display:'inline-flex' }}>● Inactivo</span>}
                      </div>
                      <RenderIf isTrue={checkUserPermission("enable_disable_paymentmethod", user.permissions) !== -1}>
                        <Form.Switch
                          type="switch" id={pm.payment_id} label=""
                          checked={pm.status === 1}
                          onChange={e => handlePaymentMethodSwitch(pm.payment_id, pm.integration_id, machine_id, e.target.checked)}
                        />
                      </RenderIf>
                    </div>

                    {pm.params.length > 0 && (
                      <div className="mmd-pm-params">
                        <span style={{ fontSize:'.67rem', fontWeight:700, letterSpacing:'.05em', textTransform:'uppercase', color:'#9CA3AF' }}>Parámetros</span>
                        {pm.params.map(param => (
                          <div className="mmd-pm-param" key={param.param_value_id}>
                            <span><span className="mmd-pm-param-name">{param.name}:</span><span className="mmd-pm-param-val">{param.value}</span></span>
                            <button className="mmd-btn-param-edit" onClick={() => { setShowEditParamValueModal(true); handleFieldChange('param_value', param.value); handleFieldChange('param_value_id', param.param_value_id); }}>
                              <IcoPen />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}

                    <div className="mmd-pm-foot">
                      <RenderIf isTrue={checkUserPermission("remove_paymentmethod_machine", user.permissions) !== -1}>
                        <button className="mmd-btn-pm-del" onClick={() => removePaymentMethod(pm.payment_id, pm.integration_id, machine_id)}>
                          <IcoTrash /> Eliminar
                        </button>
                      </RenderIf>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowModal(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      {/* ── Sub-modales — props exactos originales ── */}
      <SmartpayModal title="Asignar bodega a la máquina" modal_header_text="Asignar bodega a la máquina" modal_size="md" buttonModal={false} modal_body={modalFieldsWarehouses} setShowModal={setShowAsingWarehouseModal} showModal={showAsingWarehouseModal} formType="editForm" initialFormValues={formData} handleFieldChange={handleFieldChange} submit={asingWarehouseToMachine} />
      <SmartpayModal title="Actualizar sucursal de la Máquina" modal_header_text="Actualizar sucursal de la Máquina" modal_size="md" buttonModal={false} modal_body={modalFields} setShowModal={setShowAsingBranchModal} showModal={showAsingBranchModal} formType="editForm" initialFormValues={formData} handleFieldChange={handleFieldChange} submit={asingBranchToMachine} />
      <SmartpayModal title="Asignar categoria a la máquina" modal_header_text="Asignar categoria a la máquina" modal_size="md" buttonModal={false} modal_body={modalFieldsCategory} setShowModal={setShowAsingCategoryModal} showModal={showAsingCategoryModal} formType="editForm" initialFormValues={formData} handleFieldChange={handleFieldChange} submit={asingCategoryToMachine} />
      <SmartpayModal title="Editar valor del parametro" modal_header_text="Editar valor del parametro" modal_size="md" buttonModal={false} modal_body={modalFieldsEditParamValue} setShowModal={setShowEditParamValueModal} showModal={showEditParamValueModal} formType="editForm" initialFormValues={formData} handleFieldChange={handleFieldChange} submit={updateMachineParamPaymentMethodValue} />
      <ModalAsingPaymetMethod showModal={showAsingPaymentMethodModal} setShowModal={setShowAsingPaymentMethodModal} paymentMethodIntegrations={paymentMethodIntegrations} token={token} machine_id={machine_id} setEventHandler={setEventHandler} />

      {/* imports preservados — no-JSX */}
      {void [SuccessAlert, ErrorAlert, checkUserModules, Container, Row, Col]}
      <div style={{ display:'none' }}>
        <ListGroup as="ol"><ListGroup.Item as="li" className="d-flex justify-content-between align-items-start"><div className="ms-2 me-auto">x</div></ListGroup.Item></ListGroup>
        <Badge bg="success">x</Badge>
      </div>
    </>
  );
};

export default ModalMachineDetails;